import React from "react"
import { Card } from "antd"
import {
  MailOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons"
import { translations } from "../../utils/Translation/staticTranslation"
import "./Campaigns.css"

const CampaignStats = ({ stats }) => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.campaignsPage

  return (
    <div className="campaign-stats-container">
      <Card
        className="campaign-stat-card"
        bodyStyle={{ padding: "16px", height: "120px" }}
      >
        <div className="campaign-stat-content">
          <div className="campaign-stat-percentage"></div>
          <div className="campaign-stat-inner">
            <div className="campaign-stat-icon-wrapper campaign-stat-icon-wrapper-mail">
              <img src="/Campaign/mail.svg" width={16} height={16} />
            </div>
            <div>
              <div className="campaign-stat-value">{stats.total}</div>
              <div className="campaign-stat-label">
                {t?.stats?.total || "Total Campaigns"}
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Card
        className="campaign-stat-card"
        bodyStyle={{ padding: "16px", height: "120px" }}
      >
        <div className="campaign-stat-content">
          <div className="campaign-stat-percentage"></div>
          <div className="campaign-stat-inner">
            <div className="campaign-stat-icon-wrapper campaign-stat-icon-wrapper-calendar">
              <img src="/Campaign/calendar.svg" width={16} height={16} />
            </div>
            <div>
              <div className="campaign-stat-value">{stats.scheduled}</div>
              <div className="campaign-stat-label">
                {t?.stats?.scheduled || "Scheduled Campaigns"}
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Card
        className="campaign-stat-card"
        bodyStyle={{ padding: "16px", height: "120px" }}
      >
        <div className="campaign-stat-content">
          <div className="campaign-stat-percentage"></div>
          <div className="campaign-stat-inner">
            <div className="campaign-stat-icon-wrapper campaign-stat-icon-wrapper-checkmark">
              <img src="/Campaign/checkmark.svg" width={16} height={16} />
            </div>
            <div>
              <div className="campaign-stat-value">{stats.completed}</div>
              <div className="campaign-stat-label">
                {t?.stats?.completed || "Completed Campaigns"}
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default CampaignStats
